export const SKILL_EVENTS = {
  SKILL_DOWNLOADED: "Skill Downloaded",
} as const
